import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useNotifications } from '@sequencehq/core-components'
import { useCallback, useMemo, useState } from 'react'
import { hubSpotDealLinkErrorMessage } from '../hubSpotDealLinkError'

type UseUnlinkHubSpotDealModal = (props: {
  dealId: string
  onConfirm: () => void
}) => {
  submit: {
    onClick: () => Promise<boolean>
    disabled: boolean
    unlinking: boolean
  }
}

export const useUnlinkHubSpotDealModal: UseUnlinkHubSpotDealModal = props => {
  const { displayNotification } = useNotifications()
  const [isUnlinking, setIsUnlinking] = useState(false)

  const unlinkDeal = useCallback(async () => {
    setIsUnlinking(true)

    const res = await dashboard20240730Client.deleteHubspotDealQuoteLink({
      dealId: props.dealId
    })

    setIsUnlinking(false)

    if (res.error) {
      displayNotification(
        await hubSpotDealLinkErrorMessage(
          res.res,
          'Could not unlink the quote from HubSpot'
        ),
        { type: 'error' }
      )
      return false
    }

    displayNotification('Quote unlinked from HubSpot deal', { type: 'success' })
    return true
  }, [displayNotification, props.dealId])

  const submit = useMemo(
    () => ({
      onClick: async (): Promise<boolean> => {
        const success = await unlinkDeal()

        if (success) {
          props.onConfirm()
        }

        return success
      },
      disabled: isUnlinking,
      unlinking: isUnlinking
    }),
    [isUnlinking, unlinkDeal, props.onConfirm]
  )

  return { submit }
}
